const visualMap = document.querySelector(".visual-map svg");

if(visualMap) {
    
    let allInputs = document.querySelectorAll(".visual-map input");
    console.log(allInputs.length)
    for(let i = 0; i < allInputs.length; i++) {
        allInputs[i].addEventListener("change", () => {
            
            let allPaths = document.getElementsByClassName(allInputs[i].getAttribute("name").replaceAll(" ", "").replace("/", "").toLowerCase());
             if(allInputs[i].checked) {                  
                 for(let n = 0; n < allPaths.length; n++) {
                     allPaths[n].classList.remove("d-none")
                 }
             } else {
                 for(let n = 0; n < allPaths.length; n++) {
                     allPaths[n].classList.add("d-none")
                 }
             }
        })
    }
}
